"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultListPropertyTranslateState = void 0;
exports.defaultListPropertyTranslateState = {
    featureTitle: 'Find Home Seekers Faster',
    featureCaption: 'Questions? Call +852 2102 0888',
    featureBox: 'Enter Property Address',
    featureListNow: 'List Now',
    welcomeTitle: 'Welcome Home with OKAY.com',
    welcomeDescription: "<p>The biggest challenge that property owners face in Hong Kong is getting maximum exposure and demand for their property, and needing to work with dozens of agents to do so.</p><p>At OKAY.com, you can work with one agent and rest assured that your property is being shared throughout the agent network via our award-winning agent platform and website. Best of all - you don\u2019t have to pay any additional commission!</p>",
    learnMore: 'Learn More',
    soleAgencyTitle: 'You Only Need One Agency to List Your Property',
    soleAgencyDescription: 'There’s a common misconception that the more agencies you list with, the faster your apartment will sell. The reality is that a “general” listing is not given priority within a typical agency since it’s more likely that another agency will secure the buyer.',
    soleAgencySaveYourTime: 'Save Your Time',
    exposureTitle: 'How We Maximize Exposure for Your Property',
    exposureDescription: 'We attract thousands of clients and agents to our website every day, and are dedicated to being the top source of listings for home seekers and investors in Hong Kong through multiple powerful marketing channels.',
    exposureCaption: 'Click below to view details of what we offer you when listing your property with us.',
    exposureSoleAgencyListing: 'Sole Agent Listing',
    exposureStandardListing: 'Standard Listing',
    exposureSoleAgencyIncludeStandard: '* Includes all standard listing benefits',
    exposureAction: 'List Your Property With Us',
    successTitle: 'The Sole Agency Success Route',
    successCaption: 'Pursuing a sole agency with OKAY.com presents you with a single point of contact backed by the full arsenal of our marketing capabilities. There’s a reason why we’ve been able to generate faster sales and a high success rate!',
    successAction: 'Sell Your Property Faster',
    clientTitle: 'What our Clients Say',
    clientCaption: 'While we would love to go on about how much we can do for you, sometimes it’s best to let others do the talking.',
    sold: 'Sold',
    popupBasicTitle1: 'Hi, let’s get your property listed!',
    popupBasicTitle2: 'Please share a few details',
    popupBasicNameHint: 'Address / Building Name',
    popupBasicPrice: 'Expected Price (HKD)',
    popupBasicPriceHint: '10,000,000',
    popupBasicPriceRentHint: '20,000',
    popupBasicForSale: 'For Sale',
    popupBasicForRent: 'For Rent',
    popupBasicStatus: 'Status',
    popupBasicVacant: 'Vacant',
    popupBasicOccupied: 'Owner Occupied',
    popupBasicTenanted: 'Tenanted',
    popupNext: 'Next',
    popupConfigBath: 'Bathrooms',
    popupConfigBeds: 'Bedrooms',
    popupConfigStudio: 'Studio',
    popupConfigTitle: 'Excellent! Just 2 more simple steps to go',
    popupConfigSizeHint: 'Saleable Area (SF)',
    popupFeatureTitle: 'Almost done! This is your last step prior to submission. Click next to finalize.',
    popupFeatureFeatures: 'Features',
    popupFeatureBalcony: 'Balcony',
    popupFeatureTerrace: 'Terrace',
    popupFeatureRooftop: 'Rooftop',
    popupFeatureGarden: 'Garden',
    popupFeatureMaidsRoom: 'Maid\'s Room',
    popupFeatureCarPark: 'Car Park',
    popupFeaturePrivatePool: 'Private Pool',
    popupFeatureComments: 'Commets',
    popupFeatureCommentsHint: 'This property is ...',
    popupDone: 'Done',
    popupContactTitle1: 'Thanks for sharing details of your property!',
    popupContactTitle2: 'Please let us know how we can reach you.',
    popupContactName: 'Name',
    popupContactEmail: 'Email',
    popupContactPhone: 'Phone',
    popupContactReceiveUpdates: 'Receive Property Updates',
    popupContactConsent: 'I consent to the Advertising of my Property',
    popupContactAgree: 'I agree to the',
    popupContactTerms: 'Terms & Conditions',
    popupCompleteTitle: 'Thank you for submitting your details!',
    popupCompleteCaption1: 'We’ll be in touch within 1 business day to verify your information and confirm viewing arrangements.',
    popupCompleteCaption2: 'Should you have any immediate questions, please contact us at: +852 2102 0888 or support@okay.com',
    popupComplete: 'Complete',
    popupSubmit: 'Submit',
    popupRecapTitle: 'Oh no, don\'t go',
    popupRecapCaption: 'If you just want to talk to a member of our team, please leave your details and we’ll get in touch ASAP',
    popupRecapName: 'Name',
    popupRecapEmail: 'Email',
    popupRecapPhone: 'Phone',
    popupRecapIAgree: 'I agree to the',
    popupRecapTerms: 'Terms & Conditions',
    popupBasicAvailable: 'Available Now',
    popupBasicTenentUntil: 'Select Date',
    required: 'Required',
    invalidEmail: 'Invalid Email',
};
